import { EmailClass, EmailReport, EmailService } from "../../../../services/email.service";
import { DocumentService } from "../../../../services/document.service";
import { S25Const } from "../../../../util/s25-const";
import { Report } from "../../../../pojo/Report";

export namespace PaymentEmailSend {
    export type PaymentEmailContext = {
        eventId: number;
        evBillId: number;
        orgId: number;
        /** The manual template the message came from, recorded against the send. */
        templateId?: number;
    };

    /**
     * Sends a payment request, attaching every report the author picked.
     *
     * This is the payment form's own send path rather than `ReportService.emailPaymentReport`, which
     * carries exactly one report and is still what the legacy payments UI calls.
     */
    export async function sendPaymentEmail(
        context: PaymentEmailContext,
        email: EmailClass,
        reports: Report.SimpleObject[],
    ) {
        email.reports = await Promise.all(reports.map((report) => toEmailReport(report, context)));

        return EmailService.sendEmailFromClass(
            email,
            context.eventId,
            S25Const.itemName2Id["event"],
            true,
            undefined,
            context.templateId,
        );
    }

    async function toEmailReport(report: Report.SimpleObject, context: PaymentEmailContext): Promise<EmailReport> {
        // A document report has no output until it is run, so it is run before it can be attached.
        const documentRun = report.document_id
            ? await DocumentService.getEventDocumentRun(report.document_id, context.eventId)
            : undefined;

        if (report.document_id && !documentRun?.id) {
            throw new Error(`No documentRunId could be generated for ${report.rpt_name}`);
        }

        return {
            // Only a document report has a run to point at; the field is required all the same.
            itemID: documentRun?.id as number,
            objString: "",
            fromTemplate: false,
            rpt_id: report.rpt_id,
            rpt_engine: report.rpt_engine,
            isString: false,
            rpt_filename_runtime: documentRun?.filename,
            params: {
                num_parm1: context.eventId,
                num_parm2: context.evBillId.toString(),
                num_parm3: documentRun?.id?.toString(),
                num_parm4: context.orgId?.toString(),
                true_value: "T",
                false_value: "F",
            },
        };
    }
}
